export function Empty({ title, body, action }) {
  return (
    <div className="empty fade-in">
      <div className="empty-title">{title}</div>
      {body ? <p className="empty-body">{body}</p> : null}
      {action}
    </div>
  );
}
